export default class SingleEntry {
  constructor() {
    this.selector = '.single__entry';
  }

  bootstrap() {
    const singlePageEntry = document.querySelector(this.selector);

    if (singlePageEntry) {
      const blocks = singlePageEntry.querySelectorAll('.c-block');

      blocks.forEach(block => {
        this.updateBlockMargins(block);
      });

      window.addEventListener('resize', () => {
        blocks.forEach(block => {
          this.updateBlockMargins(block);
        });
      });
    }
  }

  updateBlockMargins(block) {
    block.style.marginLeft = null;
    block.style.marginRight = null;
    const widthDiff = (window.innerWidth - block.offsetWidth) / 2;

    block.style.marginLeft = `-${widthDiff}px`;
    block.style.marginRight = `-${widthDiff}px`;
  }
}
